import { Easing } from 'smooth-scroll';

export default {
  api: {
    baseUrl: /(localhost|yellow-flower|frontend)/.test('localhost:3000')
      ? 'https://sitecoredxp-dev.osfhealthcare.org/api/graph'
      : `https://${location.hostname}/api/graph`,
    scApiKey: '{0998559A-BD24-4663-B05C-7C677D7A8DEE}',
    epicClientID: 'b2155cc7-b75b-4b90-9f3b-f43ade2b3336',
    epicApi: 'https://ssproxy.osfhealthcare.org/dxp/',
    epicAccessToken: 'ZW1wJE9TRkRYUFBSRDpSZWoyITdqOVZ3NUg=',
    getDepartmentWaitTimes:
      'api/epic/2014/Scheduling/Utility/GetDepartmentWaitTimes/GetDepartmentWaitTimes',
    getScheduleDays:
      'api/epic/2017/PatientAccess/External/GetScheduleDaysForProvider2/Scheduling/Open/Provider/GetScheduleDays2',
    azureMapsMarkerUrl: '/images/map-marker-filled.png',
    contentHubProviderImageBaseUrl:
      'https://osf-p-001.sitecorecontenthub.cloud/api/public/content',
  },
  breakpoints: {
    xs: 0,
    sm: 375,
    md: 768,
    lg: 1280,
    xl: 1440,
    xxl: 1680,
  },
  clareWidget: {
    hideOnMobilePaths: [
      '/services/specialties/cancer/patients-families/request-appointment',
    ],
  },
  greenHeroImage:
    'https://osf-p-001.sitecorecontenthub.cloud/api/public/content/3970d7716ada4ee087652c6bab9d0f32?v=e4f99e08',
  fallbackImages: {
    location:
      'https://osf-p-001.sitecorecontenthub.cloud/api/public/content/placeholder-location-transparent',
    providerFemale:
      'https://osf-p-001.sitecorecontenthub.cloud/api/public/content/placeholder-female-provider-transparent',
    providerMale:
      'https://osf-p-001.sitecorecontenthub.cloud/api/public/content/placeholder-male-provider-transparent',
  },
  isFrontEndMode: /(localhost|yellow-flower|dxp-frontend)/.test(
    'localhost:3000'
  ),
  mapCenter: { lat: 40.8519828, lng: -89.5927631 },
  smoothScroll: {
    customEasing: (time: any) => {
      /* easeInOut CSS match */
      return 0.5 * (Math.sin((time - 0.5) * Math.PI) + 1);
    },
    easing: 'easeInOutCubic' as Easing,
    speed: 400,
  },
};
